// Puhtaat apufunktiot MyLoads-sivulle

import { supabase } from "@/integrations/supabase/client";

export interface CustomerInfo {
  first_name: string | null;
  last_name: string | null;
  company_name: string | null;
  phone: string | null;
}

export interface CustomerInfoRow {
  order_id: string;
  first_name: string | null;
  last_name: string | null;
  company_name: string | null;
  phone: string | null;
}

/**
 * Muuntaa RPC-vastauksen asiakastietojen mapiksi order_id:n mukaan
 */
export function mapCustomerInfoRows(
  rows: CustomerInfoRow[] | null | undefined
): Record<string, CustomerInfo> {
  if (!rows || rows.length === 0) return {};

  const customerInfoMap: Record<string, CustomerInfo> = {};
  
  rows.forEach((row) => {
    customerInfoMap[row.order_id] = {
      first_name: row.first_name,
      last_name: row.last_name,
      company_name: row.company_name,
      phone: row.phone,
    };
  });

  return customerInfoMap;
}

/**
 * Batch-haku asiakastiedoille useille tilauksille
 * Eliminoi N+1 -kyselyt hakemalla kaikki kerralla RPC:llä
 */
export async function fetchCustomerInfoBatch(
  orderIds: string[]
): Promise<Record<string, CustomerInfo>> {
  if (orderIds.length === 0) return {};

  const { data, error } = await supabase.rpc("get_orders_customer_info", {
    _order_ids: orderIds,
  });

  if (error) {
    console.error("Error fetching customer info:", error);
    return {};
  }

  return mapCustomerInfoRows(data as CustomerInfoRow[]);
}

/**
 * Muotoilee asiakkaan nimen näytettäväksi
 */
export function formatCustomerName(customer: CustomerInfo | null | undefined): string {
  if (!customer) return '';
  
  if (customer.company_name) {
    return customer.company_name;
  }
  
  const parts = [customer.first_name, customer.last_name].filter(Boolean);
  return parts.join(' ');
}

/**
 * Palauttaa asiakkaan puhelinnumeron tai tyhjän merkkijonon
 */
export function getCustomerPhone(customer: CustomerInfo | null | undefined): string {
  return customer?.phone || '';
}
